import styled from '@emotion/styled';
import { Accordion, Box } from '@mui/material';
import { theme } from 'theme';

export const StyledStatusDropdown = styled(Box)`
  border-radius: 8px;
  border: 1px solid #959595;
  box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.05);
  & .panel_header {
    padding: 18px 22px 17px;
    background-color: ${theme.palette.primary.light};
  }
  & .panel_body {
  }
`;

export const StyledAccordion = styled(Accordion)`
  width: 100%;
  border-radius: 0 0 8px 8px !important;
  & .MuiAccordionSummary-root {
    min-height: 80px !important;
    padding: 0 22px;
  }
  & .MuiAccordionSummary-content {
    flex-direction: column;
  }
  & .MuiAccordionDetails-root {
    padding: 0 22px;
  }
`;
